/**
 * Network and Currency Styling Configuration
 * Used for currency selector visual design
 */

export const NETWORK_TAG_STYLES = {
  'bitcoin': { bg: '#3B82F6', text: '#FFFFFF', label: 'BTC' },
  'ethereum': { bg: '#3B82F6', text: '#FFFFFF', label: 'ETH' },
  'tron': { bg: '#EF4444', text: '#FFFFFF', label: 'TRX' },
  'solana': { bg: '#A855F7', text: '#FFFFFF', label: 'SOL' },
  'bsc': { bg: '#F59E0B', text: '#FFFFFF', label: 'BSC' },
  'binance_smart_chain': { bg: '#F59E0B', text: '#FFFFFF', label: 'BSC' },
  'base': { bg: '#0052FF', text: '#FFFFFF', label: 'BASE' },
  'polygon': { bg: '#8247E5', text: '#FFFFFF', label: 'MATIC' },
  'arbitrum': { bg: '#28A0F0', text: '#FFFFFF', label: 'ARB' },
  'optimism': { bg: '#FF0420', text: '#FFFFFF', label: 'OP' },
  'avalanche': { bg: '#E84142', text: '#FFFFFF', label: 'AVAX' },
}

export const CURRENCY_COLORS = {
  'btc': '#F7931A',
  'eth': '#627EEA',
  'usdc': '#2775CA',
  'usdt': '#26A17B',
  'sol': '#14F195',
  'trx': '#FF060A',
  'bnb': '#F3BA2F',
  'matic': '#8247E5',
  'avax': '#E84142',
  'cbbtc': '#F7931A',
  'xrp': '#23292F',
  'og': '#F59E0B',
}

/**
 * Get network tag styling for a blockchain
 * @param {string} blockchain - Blockchain identifier
 * @returns {Object} Style object with bg, text, and label
 */
export function getNetworkTagStyle(blockchain) {
  const normalized = blockchain?.toLowerCase() || ''
  const style = NETWORK_TAG_STYLES[normalized] || {
    bg: '#6B7280',
    text: '#FFFFFF',
    label: blockchain?.toUpperCase() || 'N/A'
  }
  return {
    backgroundColor: style.bg,
    color: style.text
  }
}

/**
 * Get network tag label for display
 * @param {string} blockchain - Blockchain identifier
 * @returns {string} Display label
 */
export function getNetworkTagLabel(blockchain) {
  const normalized = blockchain?.toLowerCase() || ''
  const style = NETWORK_TAG_STYLES[normalized]
  return style?.label || blockchain?.toUpperCase() || 'N/A'
}

/**
 * Get currency icon background color
 * @param {string} ticker - Currency ticker symbol
 * @returns {string} Hex color code
 */
export function getCurrencyColor(ticker) {
  const normalized = ticker?.toLowerCase() || ''
  return CURRENCY_COLORS[normalized] || 'rgba(255, 255, 255, 0.1)'
}
